"use client";

import { useEffect } from "react";

export function DebugScreenSize() {
  useEffect(() => {
    const log = () => console.log(`screen: ${window.innerWidth}x${window.innerHeight}px`);

    log();
    window.addEventListener("resize", log);
    return () => window.removeEventListener("resize", log);
  }, []);

  return null;
}
